//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-stockout-apply-create',
  components: {
    FormComponent: FormComponent
  },
  data: function data() {
    return {
      id: 0
    };
  }
};